import { InvoiceDetailsModal } from '@/features/deposit-bank-transfer/ui';
import type { InvoiceDetailsProps } from '@/features/deposit-bank-transfer/api';
import { useModalStore } from '@/shared/lib';

type OpenInvoiceDetailsDialogParams = {
  mode: 'new' | 'view';
  invoiceData: InvoiceDetailsProps;
  onBack?: () => void;
  onClose?: () => void;
  onDeleted?: () => void;
  className?: string;
};

export function useInvoiceDetailsDialog() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openInvoiceDetailsDialog = ({
    mode,
    invoiceData,
    onBack,
    onClose,
    onDeleted,
    className = 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
  }: OpenInvoiceDetailsDialogParams) => {
    showDialogComponent({
      component: (
        <InvoiceDetailsModal
          mode={mode}
          invoiceData={invoiceData}
          onBack={onBack}
          onClose={onClose ?? closeDialog}
          onDeleted={onDeleted}
        />
      ),
      className,
      onClose: onClose ?? closeDialog,
    });
  };

  return { openInvoiceDetailsDialog };
}
